import { Gauge } from "lucide-react";
import {
  KpiChartParamsSchema,
  defaultSingleKpiParams,
  type KpiChartParams,
} from "@playbookai/widget-schemas";
import { registerWidget } from "../registry.js";
import type { SqlWidgetDef } from "../types.js";
import { KpiChartBody } from "../kpiChart/KpiChartBody.js";
import { KpiChartEditor } from "../kpiChart/KpiChartEditor.js";
import type { KpiChartView } from "../kpiChart/types.js";

/**
 * Single KPI — dashboard data widget. One pinned KPI as a big number +
 * sparkline (default `big-number`). Distinct from the canvas `kpiTile`
 * (recharts "Active SOLVEs" count) — intentionally NOT deduped (ADR-0015 / PB-176).
 *
 * `TParams` = saved `KpiChartParams` (`{ kpiId, chartType?, … }`, validated by
 * `WIDGET_PARAMS_SCHEMAS`); `TView` = the resolved `KpiChartView` the host
 * composes (`{ kpi: KpiDef, … }`). Canvas-only `SqlWidgetDef` fields are filled
 * with neutral defaults — this kind is dashboard-only (`modes: ["dashboard"]`).
 */
export const singleKpiDef: SqlWidgetDef<KpiChartParams, KpiChartView> = {
  kind: "singleKpi",
  label: "Single KPI",
  modes: ["dashboard"],
  singleton: false,
  defaultSize: { w: 352, h: 300 },
  defaultParams: defaultSingleKpiParams,
  Component: KpiChartBody,
  storage: "sql",
  schema: KpiChartParamsSchema,
  accent: "cyan",
  icon: Gauge,
  subtitle: "Pinned KPI",
  defaultRoster: false,
  category: "multi",
  layout: { col: 1, row: 1, width: 352, height: 300 },
  dashboard: {
    icon: Gauge,
    defaultWidth: "medium",
    category: "Operations",
    allowMultiple: true,
    supportsTitleOverride: true,
    EditorForm: KpiChartEditor,
  },
};

registerWidget(singleKpiDef);
